import {Directive, HostBinding, Input} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
 
@Directive({
  selector: '[sanitizeImage]'
})
export class SanitizeImageDirective {
 
  @Input() sanitizeImage: string;
 
  constructor(private sanitizer: DomSanitizer) {
  }
 
  @HostBinding('src')
  get Src(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.sanitizeImage);
  }
 
}
